var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#101820",
  fillRule: "evenodd",
  d: "m16.5 11-4-4-4 4zm-8 1 4 4 4-4z",
  clipRule: "evenodd"
})));
export default SvgDefault;